// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GridPageLogic__children--hidden":"cl_a bhl_c","GridPageLogic__locations__placesRadius":"cl_b bhl_sv"};